import React from 'react';
import { Img } from './styles';

function Image({src,width='',height='', ...props}) {
    return(
        <Img src={src} width={width} height={height} {...props}/>
    )
}

export default Image;